module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAUpJREFUOE+lU8tVAkEQrNrFA14kBIzAfSwHdk9jBhiBGIFkoGRABmIGGgFzWjiwOmZACHBWpn3DY2B3Hz+fc5vp6urq6h7in4cuP4pUo1bHEwjlrgIsINArYmAybY7VYNRRzZAYk2juA1qLh4+pHsWpMgRuihgRzFkNCPBVBf5YXIeEIXFVIVgyTtSQxKNLXFl0zVTPXUvhJXSBaDDL9PM+hWsP4kR1VwLjkj0oTtSIxP3mfpygyLyuXscLia5/dz7YAOZCWGrhm7JcK/AnSlUUAmMCDf8mgtd8onvtVMnBFgqyF94oESxF0HcT2LQ5JBCVTCQWJQXFKiK4yyf67dSelQhaHdULAjStxdxX/juBc57Qs0wPWonqB5XZV/Zg14IzsAZ8bgEWtwgwPltBu6NUMcGPrmZ3EzlnCn4r3/NMb/fg6Gc6JfFU/BfChoDQlRKeEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/ic_danhmuccauhoi.png
// module id = 1266
// module chunks = 0